/**
 * Created by Vladislav on 03.09.2026
 */

CupsConfig.TYPE_WEEKLY = "weekly";

CupsConfig.TYPES[CupsConfig.TYPE_WEEKLY] = {
    available: cleverapps.config.availables.WEEKLY_CUP,
    scenes: [cleverapps.Environment.SCENE_LOADER, cleverapps.Environment.SCENE_MAIN],
    rewards: RewardsConfig.WeeklyCup,
    duration: cleverapps.parseInterval("1 week"),
    cooldown: 0,
    restartAfter: cleverapps.parseInterval("1 minute"),
    topLimit: 25
};

if (cleverapps.config.debugMode || typeof cc === "undefined" && process.env.NODE_ENV !== "production") {
    CupsConfig.TYPES[CupsConfig.TYPE_WEEKLY].duration = cleverapps.parseInterval("3 minutes");
}
